import { getApplicantPortalTermsOfUseUrl } from "@certn/utils";
import { useTranslation } from "react-i18next";

import { HelpAndPrivacyLinkItem } from "./HelpAndPrivacyLinkItem";

export function TermsOfUse() {
  const { t, i18n } = useTranslation();
  const applicantPortalTermsOfUseUrl = getApplicantPortalTermsOfUseUrl(
    i18n.language
  );

  return (
    <HelpAndPrivacyLinkItem
      testID="help-and-privacy-terms-of-use-view-button"
      item={t("Terms of use")}
      description={t("Learn about our terms here")}
      linkText={t("View")}
      link={applicantPortalTermsOfUseUrl}
    />
  );
}
